<template lang="pug">
  .consultation--category.pt-6
    input-fields(
      :fields="firstFields"
      @add-group="(field_id) => $emit('add-group', field_id)"
      @del-group="(field_id, id) => $emit('del-group', field_id, id)"
      @update="(id, v) => $emit('update', id, v)"
    )

    v-expansion-panels.flat-panels(flat tile multiple)
      v-expansion-panel.my-3(
        v-for="(building, index) in buildings_"
        :key="index"
      )
        v-expansion-panel-header.flat-panel-header
          v-flex.xs12.lg12.xl12(:key="building.id")
            h4.primary--text Gebäude „{{ building.name }}“

        v-expansion-panel-content(eager)
          input-fields(
            :fields="building.fields"
            :is-building="true"
            @add-group="(field_id) => $emit('add-group', field_id)"
            @del-group="(field_id, id) => $emit('del-group', field_id, id)"
            @update="(id, v) => $emit('update', id, v)"
          )

    input-fields(
      :fields="lastFields"
      @add-group="(field_id) => $emit('add-group', field_id)"
      @del-group="(field_id, id) => $emit('del-group', field_id, id)"
      @update="(id, v) => $emit('update', id, v)"
    )

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    FieldRow: () => import('./field-row')
  },
})
export default class Category extends Vue {
  @Prop({ type: Array, default: () => [] }) fields
  @Prop({ type: Object, default: () => {} }) buildings

  get firstFields () {
    return this.fields
      .filter(f => !f.styling || f.styling.position !== 'last')
  }

  get lastFields () {
    return this.fields
      .filter(f => f.styling && f.styling.position === 'last')
  }

  get buildings_ () {
    return Object.values(this.buildings || {})
      .filter(b => !b.hidden)
      .sort((a, b) => a.sortIndex - b.sortIndex)
  }
}
</script>

<style lang="sass">
.group-add-row
  top: 202px
</style>
